import { IPage, ISort } from './request';

import { IUser } from './user';

export enum statusEnum {pending, taken, close}

export interface ITicket {
  closingTs: number;
  creationTs:	number;
  description:	string;
  id:	string;
  lastUpdate:	string;
  operatorProfile: IHealthWorkerProfile;
  requesterProfile: IRequesterProfile;
  result:	string;
  status: number;
  takeInChargeTs: string;
  isServer: number;
}

export interface IHealthWorkerProfile {
  type:	number;
  user:	IUser;
  userId: number;
}

export interface ITicketRequest {
  requesterId:	number;
  operatorId: number;
  description: string;
  result: string;
}

export interface ITicketResponse {
  content: Array<ITicket>;
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: IPage;
  size: number;
  sort: ISort;
  totalElements: number;
  totalPages: number;
  operatorProfile: IHealthWorkerProfile;
  requesterProfile: IRequesterProfile;
}

export class CloseTicketRequest {
  requesterId: string;
  operatorId: string;
  description: string;
  result: string;

  constructor(ticket: ITicket) {
    this.operatorId = ticket.operatorProfile.user.id;
    this.requesterId = (ticket.requesterProfile) ? ticket.requesterProfile.user.id : null;
    this.description = ticket.description;
    this.result = ticket.result;
  }
}

export interface IRequesterProfile {
  imgUrl: string;
  user: IUser;
  userId: number;
}

export class TicketResponse implements ITicketResponse {
  content: Array<ITicket>;
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: IPage;
  size: number;
  sort: ISort;
  totalElements: number;
  totalPages: number;
  operatorProfile: IHealthWorkerProfile;
  requesterProfile: IRequesterProfile;

  constructor(data) {
    this.content = data;
  }
}
